import { useState } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

import { useTelegramWebApp } from "../../hooks/useTelegramWebApp.js";

import { PRODUCTS } from "./products.js";
import { promoDismissal } from "./dismissal.js";

const TGPE_DESKTOP = PRODUCTS.find((p) => p.id === "tgpe_desktop");

/**
 * Persistent compact card visible at the bottom of the editor. Drives
 * users to TGPE Desktop. Dismissable; persists dismissal in localStorage
 * and re-shows after 7 days.
 */
export function PromoFooter() {
  const { t } = useTranslation();
  const wa = useTelegramWebApp();
  const [hidden, setHidden] = useState(() =>
    promoDismissal.isDismissed(new Date()),
  );

  if (hidden || !TGPE_DESKTOP) return null;

  function open() {
    if (!TGPE_DESKTOP) return;
    const url = TGPE_DESKTOP.url();
    if (wa?.openLink) wa.openLink(url);
    else window.open(url, "_blank", "noopener,noreferrer");
  }

  function dismiss() {
    promoDismissal.dismiss(new Date());
    setHidden(true);
  }

  return (
    <div
      role="region"
      aria-label="TGPE Desktop promotion"
      className="flex items-center gap-2 border-t border-[var(--tg-secondary-bg)] bg-[var(--tg-bg)] px-3 py-1.5 text-[11px] text-[var(--tg-hint)]"
    >
      {TGPE_DESKTOP.iconUrl ? (
        <img
          aria-hidden
          src={TGPE_DESKTOP.iconUrl}
          alt=""
          className="h-4 w-4 shrink-0 object-contain opacity-70"
        />
      ) : (
        <span aria-hidden className="text-xs opacity-70">
          {TGPE_DESKTOP.icon}
        </span>
      )}
      <button
        type="button"
        onClick={open}
        className="min-w-0 flex-1 truncate text-left hover:text-[var(--tg-link)]"
      >
        <span className="text-[var(--tg-text)]">
          {t("cross_promo.footer.title")}
        </span>
        <span className="mx-1.5 opacity-50">·</span>
        <span className="text-[var(--tg-link)] underline-offset-2 hover:underline">
          {t("cross_promo.footer.cta")}
        </span>
      </button>
      <button
        type="button"
        aria-label={t("cross_promo.footer.dismiss")}
        onClick={dismiss}
        className="-mr-1 inline-flex h-6 w-6 items-center justify-center rounded-md text-[var(--tg-hint)] opacity-70 hover:bg-[var(--tg-secondary-bg)] hover:opacity-100"
      >
        <X size={14} />
      </button>
    </div>
  );
}
